// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/bloom_blur.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'bloom_blurPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform mediump sampler2D sourceSampler;
uniform vec2 direction;
const float weights[] = float[](0.0092,	0.0278,	0.0656,	0.1210,	0.1747,	0.1974,	0.1747,	0.1210,	0.0656,	0.0278,	0.0092);
const float weightCount = 11.0;
void main(void)
{
vec4 result = vec4(0.0);
for(float x = 0.0; x < weightCount; x++) {
float k = x - (weightCount - 1.0) * 0.5;
result += weights[int(x)] * texelFetch(sourceSampler, ivec2(gl_FragCoord.xy + k * direction), 0);
}
gl_FragColor = result;
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const bloom_blurPixelShader = { name, shader };
//# sourceMappingURL=bloom_blur.fragment.js.map